export default __webpack_public_path__ + "static/media/TTANewGirl.21ab2407.svg";